// Pranima theme — sticky header, mobile nav, reveal, buy box, sticky buy bar
document.addEventListener('DOMContentLoaded', function () {
  var header = document.querySelector('[data-site-header]');
  if (header) {
    var onScroll = function () {
      if (window.scrollY > 60) {
        header.classList.add('is-scrolled');
      } else {
        header.classList.remove('is-scrolled');
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  var burger = document.querySelector('[data-menu-toggle]');
  var mobileNav = document.querySelector('[data-mobile-nav]');
  if (burger && mobileNav) {
    burger.addEventListener('click', function () {
      var isOpen = mobileNav.classList.toggle('is-open');
      burger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      burger.querySelectorAll('[data-icon-menu], [data-icon-close]').forEach(function (el) {
        el.style.display = 'none';
      });
      var showIcon = burger.querySelector(isOpen ? '[data-icon-close]' : '[data-icon-menu]');
      if (showIcon) showIcon.style.display = '';
    });
    mobileNav.querySelectorAll('a, button').forEach(function (link) {
      link.addEventListener('click', function () {
        mobileNav.classList.remove('is-open');
        burger.setAttribute('aria-expanded', 'false');
      });
    });
  }

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var revealSections = Array.prototype.slice.call(document.querySelectorAll('#MainContent .shopify-section > section')).slice(1);
  if (revealSections.length && !reduceMotion && 'IntersectionObserver' in window) {
    var revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0, rootMargin: '0px 0px -15% 0px' });
    revealSections.forEach(function (el) {
      el.classList.add('reveal');
      revealObserver.observe(el);
    });
  }

  // Bloc d'achat : quantité -> lien panier + prix affiché
  document.querySelectorAll('[data-buy-box]').forEach(function (box) {
    var link = box.querySelector('[data-buy-link]');
    var priceEl = box.querySelector('[data-buy-price]');
    box.querySelectorAll('input[name="buy-qty"]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (link) link.href = box.dataset.cart + '/' + box.dataset.variant + ':' + radio.value;
        if (priceEl) priceEl.textContent = radio.dataset.price;
      });
    });
  });

  // Barre d'achat mobile : visible après le premier écran, masquée quand un bloc d'achat est visible
  var sticky = document.querySelector('[data-sticky-buy]');
  if (sticky) {
    var buyZones = document.querySelectorAll('[data-buy-box], .hero__actions, .closing-cta, .site-footer, .waitlist');
    var zonesVisible = 0;
    var update = function () {
      var show = window.scrollY > window.innerHeight * 0.8 && zonesVisible === 0;
      sticky.classList.toggle('is-visible', show);
    };
    if ('IntersectionObserver' in window && buyZones.length) {
      var zoneObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) { entry.target.__inView = true; } else { entry.target.__inView = false; }
        });
        zonesVisible = Array.prototype.filter.call(buyZones, function (z) { return z.__inView; }).length;
        update();
      });
      buyZones.forEach(function (z) { zoneObserver.observe(z); });
    }
    window.addEventListener('scroll', update, { passive: true });
    update();
  }

  // Liste d'attente : posologie instantanée selon le poids
  document.querySelectorAll('[data-weight-select]').forEach(function (select) {
    var form = select.closest('form');
    var out = form ? form.querySelector('[data-weight-result]') : null;
    if (!out) return;
    var price = parseInt(select.dataset.price, 10) || 2754;
    select.addEventListener('change', function () {
      var opt = select.options[select.selectedIndex];
      var chews = parseInt(opt.dataset.chews, 10);
      if (!chews) return;
      var days = Math.floor(60 / chews);
      var perDay = (price * chews / 60 / 100).toFixed(2).replace('.', ',');
      out.textContent = 'Pour votre chien : ' + chews + ' bouchée' + (chews > 1 ? 's' : '') + ' par jour. Un sachet dure ' + days + ' jours, soit ' + perDay + ' € par jour.';
    });
  });
});
